export default __webpack_public_path__ + "static/media/user-logo.840cb841.svg";